import { ReactNode } from 'react';

import { CartesiaIcon } from '../../icons/Cartesia';
import { DeepgramIcon } from '../../icons/Deepgram';
import { ElevenLabsIcon } from '../../icons/ElevenLabs';
import { GoogleIcon } from '../../icons/Google';
import { MiniMaxIcon } from '../../icons/MiniMax';
import { RimeIcon } from '../../icons/Rime';
import { SonioxIcon } from '../../icons/Soniox';
import { SpeechModel, SpeechModelProvider, SpeechProvider } from '../../types';

export const SPEECH_PROVIDER_NAMES: Record<SpeechModelProvider, string> = {
  elevenlabs: 'ElevenLabs',
  cartesia: 'Cartesia',
  minimax: 'MiniMax',
  soniox: 'Soniox',
  deepgram: 'Deepgram',
  rime: 'Rime',
  google: 'Google',
};

export const SPEECH_PROVIDER_ICONS: Partial<Record<SpeechModelProvider, ReactNode>> = {
  elevenlabs: <ElevenLabsIcon className="size-4" />,
  cartesia: <CartesiaIcon className="size-4" />,
  minimax: <MiniMaxIcon className="size-4" />,
  soniox: <SonioxIcon className="size-4" />,
  deepgram: <DeepgramIcon className="size-4" />,
  rime: <RimeIcon className="size-4" />,
  google: <GoogleIcon className="size-4" />,
};

// The API allows several speech models per provider; the console keeps one.
export const getProviderOptions = (providers: SpeechProvider[], speechModels: SpeechModel[]) => {
  const used = new Set(speechModels.map(({ provider }) => provider));
  return providers
    .filter(({ speech_model_supported }) => speech_model_supported)
    .map(({ provider }) => ({ provider, disabled: used.has(provider) }));
};
